import { render, staticRenderFns } from "./printSales.vue?vue&type=template&id=70398214&scoped=true&"
import script from "./printSales.vue?vue&type=script&lang=js&"
export * from "./printSales.vue?vue&type=script&lang=js&"
import style0 from "./printSales.vue?vue&type=style&index=0&id=70398214&lang=less&scoped=true&media=print&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70398214",
  null
  
)

component.options.__file = "printSales.vue"
export default component.exports